import React, { useCallback, useEffect, useState } from "react";

import Context from "./index";

const PermissionsProvider = (props) => {
  const [permissions, setPermissions] = useState(
    JSON.parse(localStorage.getItem("permissions")) || [],
  );

  console.log("permissions", permissions);

  const hasPermission = useCallback(
    (permission) => permissions.includes(permission),
    [permissions],
  );

  return (
    <Context.Provider
      value={{
        hasPermission,
        permissions,
        setPermissions,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default PermissionsProvider;
